export { getAriaForTrigger } from '../internal/get-aria-for-trigger';
